import style from './plans.module.scss'
import CardPlan from "../../components/cardPlans";
import roteador from "../../assets/9-3-1.png"
import {ContainerViewBoard} from "../../components/containerViewBoard";

const Plans = () => {
  const plans = [
    {
      megas: 200,
      download: 200,
      upload: 200,
      balance: 69.90,
    },
    {
      megas: 600,
      download: 600,
      upload: 600,
      balance: 84.90,
    },
    {
      megas: 700,
      download: 700,
      upload: 700,
      balance: 99.90,
    }
  ];

  const handleClick = (event: Event) => {
    console.log(event)
  }

  return (
    <div className={style.root}>
      <div className={style.container}>

        <ContainerViewBoard>
          <div className={`${style.children} ${style.bottomCenter}`}>
            <img src={roteador} className={style.roteador} alt={''}/>
          </div>
        </ContainerViewBoard>

        <ContainerViewBoard>
          <div className={`${style.children} ${style.bottomCenterText}`}>
            <p style={{marginBottom: 30}}> ** PC Connect: serviço de cabeamento para o seu dispositivo em até 10 metros,
              e que esteja dentro do mesmo ambiente comercial ou residencial </p>
          </div>
        </ContainerViewBoard>

        <ContainerViewBoard>
          <div className={`${style.children} ${style.center}`}>
            <div style={{marginBottom: 50}} className={style.slider}>
              <div className={style.slideTrack}>
                {plans.map((item) => (
                  <div className={style.slider}>
                    <CardPlan
                      megas={item.megas}
                      download={item.download}
                      upload={item.upload}
                      balance={item.balance}
                      onClick={handleClick}/>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </ContainerViewBoard>


      </div>
    </div>
  );
};

export default Plans;
